import React, { useEffect, useState } from 'react'
import { Grid, Box, Button } from '@mui/material'
import Masonry from '@mui/lab/Masonry';
import { useSelector } from 'react-redux'
import { motion } from "framer-motion/dist/framer-motion"
import { selectFilteredArticles } from '../../../reducers/healthshelf_article'
import ArticleItem from './ArticleItem'
import RecipeItem from './RecipeItem';
import HowToItem from './HowToItem';
import ChallengeItem from './ChallengeItem';
import SelfCheckItem from './SelfCheckItem';
import TrackerItem from './TrackerItem';
import { ArrowDownwardOutlined, KeyboardArrowDown } from '@mui/icons-material';


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const ArticleContainer = (props) => {

    const Articles = useSelector(state => selectFilteredArticles(state))
    const ArticlesToLoad_Default = 11
    const ArticlesToLoad_Increment = 9
    const [ArticlesToLoad, setArticlesToLoad] = useState(ArticlesToLoad_Default)

    const handleMoreArticles = () => {
        setArticlesToLoad(ArticlesToLoad + ArticlesToLoad_Increment)
    }
    useEffect(() => {
        setArticlesToLoad(ArticlesToLoad_Default)
    }, [Articles])


    const ReturnArticle = (props) => {
        let ArticleObject = props.ArticleObject
        if (ArticleObject.Type === 'ARTICLE') {
            return <ArticleItem ArticleId={ArticleObject.Id} />
        }
        else if (ArticleObject.Type === 'RECIPE') {
            return <RecipeItem ArticleId={ArticleObject.Id} />
        }
        else if (ArticleObject.Type === 'HOW TO') {
            return <HowToItem ArticleId={ArticleObject.Id} />
        }
        else if (ArticleObject.Type === 'CHALLENGE') {
            return <ChallengeItem ArticleId={ArticleObject.Id} />
        }
        else if (ArticleObject.Type === 'SELF CHECK') {
            return <SelfCheckItem ArticleId={ArticleObject.Id} />
        }
        else if (ArticleObject.Type === 'TRACKER') {
            return <TrackerItem ArticleId={ArticleObject.Id} />
        }
        // need SELF CHECK, HOW TO, CHALLENGE, TRACKER, RECIPE
        else {
            return <ArticleItem ArticleId={ArticleObject.Id} />
        }
    }

    return (

        <Box p={2} mt={1}>
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <Grid container direction="row" alignItems="stretch" justifyContent="center" spacing={1}>
                        {
                            Articles.filter((x, i) => { return i <= ArticlesToLoad }).map((x, i) => {
                                return (
                                    <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                                        <motion.div
                                            variants={motionVariants}
                                            style={{ height: "100%" }}
                                            initial="hidden"
                                            whileInView="show"
                                            whileHover={{ scale: 1.1 }}

                                        >
                                            <ReturnArticle ArticleObject={x} />
                                        </motion.div>
                                    </Grid>

                                )
                            })
                        }
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Box justifyContent={"center"} alignItems="center">
                        <Button
                            variant="contained"
                            onClick={handleMoreArticles}
                            fullWidth
                        >Load More <KeyboardArrowDown /></Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )

}

export default ArticleContainer